import pako from 'pako';

// use base64 decoder for old browsers
import base64 from './base64';

// where does this come from?
var magic = 4194303;

/**
 * This function parses the encrypted and lzipped availability feed
 * returns the xml string representing the availability feed
 *
 * @return {Document|Error}
 */
export default function (rawData) {

  if (!rawData) {
    return false;
  }

  // base64Decode
  var data = base64.decode(rawData);

  var bytePosition = -1;

  // This is a magic seed number from the language file (message 79)
  var procVector = [0xA5];

  var nextByte = function () {
    return data.charCodeAt(++bytePosition);
  };

  var numberOfBytes = nextByte();
  var om = nextByte();
  var step = nextByte(); // unused
  var vectorSize = nextByte();
  var sCompress = nextByte();

  if (data.length <= numberOfBytes && om != 1) {
    return new Error('Error decoding encoding');
  }

  // Seed the result vector up to vector size
  var limit = (vectorSize - 1);
  for (var i = 0; i < limit; ++i) {
    procVector.push(nextByte());
  }

  var output = "";

  while (bytePosition < data.length) {
    var currentByte = nextByte();
    var ssa = sCompress * procVector[0] & magic;

    for (i = 1; i < vectorSize - 1; i++) {
      var es = procVector[i];
      ssa = (ssa + es) * sCompress & magic;
    }

    ssa = ssa + procVector[vectorSize - 1];
    var mes = ssa >> 12 & 255;
    var us = ssa % vectorSize;
    procVector[us] = procVector[us] ^ sCompress;
    currentByte = currentByte ^ mes;
    output += String.fromCharCode(currentByte);
    sCompress = currentByte;
  }

  var inflator = new pako.Inflate({to: 'string'});
  inflator.push(output, true);

  if (inflator.err) {
    console.error(inflator.err);
    return new Error('Error unzipping availability');
  }

  var availabilityXml = '<xml>' + inflator.result + '</xml>';

  return availabilityXml;
};



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-availability/utils/decrypt.js